import React from "react";

import background from '@cover/updatestarten/background-1.jpg';
import backgroundSm from '@cover/updatestarten/background-1-sm.jpg';
import UpdateStarten from "../components/cover/animations/updatestarten";

import articleSrc from '@assets/article.svg';
import eyeSrc from '@assets/eye.svg';

export const meta = {
	category: "start",
	slug: "update",
	id: "UpdateStarten",
	excerpt: {
		before: "Seit 2019 fährt Felicitas Mundel mit dem Erlebnis-Lern-Truck ",
		italic: "expedition d ",
		after: "Schulen in Baden-Württemberg an, um Jugendlichen die Digitalisierung der Arbeitswelt näherzubringen."
	},
	name: "updatestarten",
	title: "Elektronik im Bauch",
	animation: UpdateStarten,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		alt: "Felicitas Mundel, Trainerin im Programm expedition d, lächelt. Um Sie herum schweben Chips, IT-Icons und Bruchteile von Programmiercode."
	}
}

const UpdatestartenArticle = () => {
	return (
		<div>
			<p className="articleParagraph">
				Seit 2019 fährt Felicitas Mundel in einem Erlebnis-Lern-Truck Schulen in Baden-Württemberg an, um Jugendlichen die Digitalisierung der Arbeitswelt näherzubringen. Sie ist im Auftrag von <i>expedition d</i> unterwegs, einer Initiative zur digitalen Berufsbildung der Baden-Württemberg Stiftung. Im Interview erzählt die Geowissenschaftlerin, was in dem ungewöhnlichen Expeditionsmobil passiert und dass dort auch Digital Natives an ihre Grenzen stoßen. 
			</p>
			<p className="articleQuestion">
				Eine digitale Erlebniswelt verpackt in einem Truck – was war die ursprüngliche Idee, einen Truck in die Welt zu schicken? 
			</p>
			<p className="articleAnswer">
				Digitalisierung ist ein großes Thema. Sie verändert nicht nur unseren Alltag, sondern vor allen Dingen auch die Berufswelt sehr stark. Wir wollen Schülerinnen und Schüler bei ihrer Berufswahl unterstützen. In dem Expeditionsmobil zeigen wir, wie die Digitalisierung die Berufswelt verändert und welche Jobs oder Studienfächer infrage kommen, wenn man die technologische Entwicklung aktiv mitgestalten möchte.
			</p>
			<p className="articleQuestion">
				Wie ist das Expeditionsmobil aufgebaut?
			</p>
			<p className="articleAnswer">
				Es ist ein zweistöckiger Erlebnis-Lern-Truck. Im unteren Stockwerk haben wir Stationen zu unterschiedlichen digitalen Technologien. Das Herzstück ist eine sechs Meter breite Multimediawand aus mehreren Touch-Bildschirmen, an der Schülerinnen und Schüler gleichzeitig werkeln können. Im Raum verteilt sind außerdem viele haptische Stationen, an denen die Jugendlichen Geräte wie eine Virtual-Reality-Brille, einen kollaborativen Roboter oder verschiedene Sensoren selbst ausprobieren können.
			</p>
			<p className="articleQuestion">
				Und wie läuft so ein Tag im Truck ab? 
			</p>
			<p className="articleAnswer">
				Ein ganzer Tag ist es für die Schülerinnen und Schüler natürlich nicht. Im Basisformat machen wir mit der Schulklasse einen 90-minütigen geführten Rundgang. Erst gibt es eine kurze Einleitung, dann arbeiten die Schülerinnen und Schüler mithilfe der Stationen an einer Aufgabe. Am Ende tragen sie ihre Ergebnisse zusammen und wir besprechen sie gemeinsam. Das passiert im Obergeschoss des Trucks, wo wir eine Art Seminarraum mit Sitzgelegenheiten haben. 
			</p>
			<p className="articleQuestion">
				Was interessiert die Schülerinnen und Schüler besonders? Gibt es ein Highlight?
			</p>
			<p className="articleAnswer">
				Gerade die jüngeren Schülerinnen und Schüler finden die VR-Brille toll. Außerdem ist unser kleiner kollaborativer Roboter, der mit Menschen zusammenarbeiten kann, sehr beliebt. Die Jugendlichen können ihn so programmieren, dass er ein Objekt greift und an einer anderen Stelle wieder ablegt. Das stößt immer wieder auf große Begeisterung.
			</p>
			<p className="articleQuestion">
				Inwieweit wird in dieser spielerischen Atmosphäre den Jugendlichen klar, dass es um ihre berufliche Zukunft geht und nicht ums Gaming?
			</p>
			<p className="articleAnswer">
				Die Jugendlichen haben einen konkreten Arbeitsauftrag, den sie während des Rundgangs erfüllen müssen. Sie bilden Kleingruppen und haben ein Tablet als Arbeitsmedium. Ihr Arbeitsauftrag könnte zum Beispiel ein digitales Produkt sein, das sie gemeinsam entwickeln möchten. Das sind Produkte, die sehr stark auf die Arbeitswelt bezogen sind wie der digitale OP-Assistent oder das digitale Fitnessstudio. Die Jugendlichen haben dann circa eine Dreiviertelstunde Zeit, ihre Aufgabe mithilfe der Schlüsseltechnologien an den Stationen zu lösen. Außerdem erfahren sie an den Stationen mehr über die konkreten Berufe, die mit den Technologien zusammenhängen.
			</p>
			<p className="articleQuestion">
				Haben Sie ein konkretes Beispiel? 
			</p>
			<p className="articleAnswer">
				Nehmen wir das digitale Fitnessstudio. Eine Gruppe hat diese Aufgabe gewählt und im Truck die VR-Brille kennengelernt und etwas über Datenbanken und Sensorik erfahren. Die Jugendlichen setzen sich zusammen und denken sich vielleicht eine smarte Yogamatte aus, die über Sensoren feststellen kann, ob die Übenden die Positionen richtig oder falsch ausführen. Über die VR-Brille könnten sie mit dem Trainer verbunden sein, der ihnen zeigt, wie es richtig geht. Und in der Datenbank werden ihre Trainingserfolge gespeichert. Wir möchten die Jugendlichen dafür sensibilisieren, wie sie unterschiedliche Technologien so zusammenbringen, dass am Ende eine Idee für eine mögliche Innovation entsteht.  
			</p>
			<p className="articleQuestion">
				Was ist das Fazit der Schülerinnen und Schüler? Was nehmen die aus den 90 Minuten mit?
			</p>
			<p className="articleAnswer">
				Häufig sagen sie, dass sie gern länger im Truck geblieben wären. Wir haben eben sehr viele verschiedene Stationen an Bord, da will man natürlich alles ausprobieren. Es gibt auch Jugendliche, die meinen, schon alles zu kennen. Aber das verändert sich oft, wenn sie erfahren, wie die Technologien ineinandergreifen und welche Berufsbilder damit zusammenhängen. Und dass gerade angesichts der Möglichkeiten digitaler Technologien Teamfähigkeit, Kreativität und die Kompetenz, Probleme zu lösen gebraucht werden, um die Arbeitswelt von morgen zu gestalten. Das zu vermitteln, ist uns sehr wichtig. 
			</p>
			<p className="articleQuestion">
				Erleben Sie bei den digitalen Kompetenzen von Schülerinnen und Schülern Unterschiede?
			</p>
			<p className="articleAnswer">
				Das ist schwer zu sagen, weil wir ja immer nur einen kleinen Einblick haben. Worin Jugendliche superfit sind, ist die Bedienung von Touchscreens und Apps. Wir merken aber auch, dass manchen Text- oder Präsentationsprogramme Schwierigkeiten bereiten. Da fehlt es oft an Grundlagen wie einen Ordner zu öffnen, ein Bild in ein Chart einzufügen, oder dass das Öffnen einer Datei einen Doppelklick erfordert. Das kann ein Hinweis darauf sein, dass in einigen Schulen noch nicht regelmäßig mit dem Computer gearbeitet wird.
			</p>
			<p className="articleQuestion">
				Inwiefern können außerschulische Angebote solche Lücken schließen? Haben Schulen es versäumt, digitale Grundlagen zu vermitteln?
			</p>
			<p className="articleAnswer">
				Das klingt ein bisschen hart. Es liegt sicherlich auch an der Ausstattung, sowohl materiell, zeitlich als auch personell. Ich denke allerdings schon, dass es wichtig ist, die digitalen Kompetenzen von Jugendlichen im wahrsten Sinne des Wortes zu schulen. Digital Native bedeutet ja nicht unbedingt auch Digital Literacy: Dass man mit Touchscreen und Apps aufgewachsen ist, sagt nichts darüber aus, dass man auch über die digitalen Kompetenzen verfügt, die für die Berufswelt relevant sind.
			</p>
			<p className="articleQuestion">
				Während der Corona-Pandemie haben Sie Ihre Tour online veranstaltet. Geht das überhaupt bei einer Konzeption, die aufs Experimentieren und auf unmittelbare Begegnung setzt?
			</p>
			<p className="articleAnswer">
				Das ist natürlich ein Riesenunterschied. Online kann man einfach keine Roboter ausprobieren. Und auch der direkte Kontakt zu den Schülerinnen und Schülern fehlt uns. Weil die Jugendlichen bei unseren Online-Workshops aus Datenschutzgründen keine Webcams anhaben, bekommen wir nicht mit, in welcher Verfassung sie sind. Sind sie unruhig? Oder müde, weil sie schon den ganzen Vormittag Unterricht hatten? Wenn man sich face to face gegenübersteht, kann man auf solche Situationen besser reagieren. Trotzdem ist die Online-Variante eine gute Alternative, vor allem in einer Zeit, in der pandemiebedingt die Berufsorientierung an Schulen fast gar nicht stattfindet. Wir freuen uns aber auch, wenn wir mit dem Truck wieder losfahren können – natürlich mit einem Hygienekonzept.
			</p>
			<a href="https://www.coaching4future.de/programm/startseite/" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					COACHING4FUTURE
					<div className="articleLinkSource">
					coaching4future.de
					</div>
				</div>
			</a>
			<a href="https://www.youtube.com/watch?v=ZK2VMbQCL60" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={eyeSrc} />
				</div>
				<div>
					Go Digital mit expedition d
					<div className="articleLinkSource">
					YouTube
					</div>
				</div>
			</a>
		</div>
	)
};

export default UpdatestartenArticle;